<template>
  <b-container style="padding-top: 150px;">
    <p class="c2"><span class="c1">Privacy Policy for D3rriana</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">Effective Date: September 14, 2023</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">1. Introduction</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >Welcome to {{ appName }} (the &quot;MyApp&quot;), provided by
        {{ companyName }} (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;).
        Protecting your privacy is important to us. This Privacy Policy explains
        how we collect, use, disclose, and protect your personal information
        when you use the {{ appName }} MyApp.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">2. Information We Collect</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >2.1. Information You Provide: We may collect personal information that
        you voluntarily provide to us, including but not limited to:</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >- Contact information (e.g., name, email address, phone number).</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Profile information (e.g., age, gender, location).</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Health-related information (e.g., medical history, caregiving
        needs).</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- User-generated content (e.g., comments, reviews).</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >2.2. Information We Automatically Collect: We may collect certain
        information automatically when you use the {{ appName }} MyApp,
        including:</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >- Device information (e.g., device type, operating system).</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Log data (e.g., IP address, browser type, access times).</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Usage information (e.g., pages visited, features used).</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >2.3. Cookies and Similar Technologies: We may use cookies and similar
        tracking technologies to enhance your user experience and collect
        information about your interactions with the {{ appName }} MyApp.
        You can manage your cookie preferences through your browser
        settings.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">3. How We Use Your Information</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >We may use your personal information for the following purposes:</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >- To provide and improve the {{ appName }} services.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- To personalize your user experience and deliver relevant
        content.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- To communicate with you, respond to your inquiries, and provide
        customer support.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- To conduct research and analysis to improve our services.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- To comply with legal obligations and enforce our Terms and
        Conditions.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">4. How We Share Your Information</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >We may share your personal information with the following third
        parties:</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >- Service Providers: We may share your information with trusted service
        providers who assist us in delivering and improving our services.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Legal Compliance: We may disclose your information to comply with
        legal obligations, protect our rights, and respond to lawful requests
        from government authorities.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Business Transfers: In the event of a merger, acquisition, or sale of
        assets, your information may be transferred to the acquiring
        entity.</span
      >
    </p>
    <p class="c2">
      <span class="c1"
        >- Your Consent: We may share your information with your consent or as
        otherwise described at the time of collection.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">5. Your Choices</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >5.1. Access and Correction: You have the right to access and update
        your personal information. You can do this by logging into your account
        or contacting us.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >5.2. Marketing Communications: You can opt out of receiving promotional
        emails from us by following the instructions provided in those emails.
        Please note that you may still receive transactional communications
        related to your {{ appName }} account.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">6. Data Security</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >We take reasonable measures to protect your personal information from
        unauthorized access, disclosure, alteration, or destruction. However, no
        data transmission over the internet or method of electronic storage is
        entirely secure, and we cannot guarantee absolute security.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">7. Children&#39;s Privacy</span></p>
    <p class="c2">
      <span class="c1"
        >The {{ appName }} MyApp is not intended for children under the age
        of 18. We do not knowingly collect personal information from children.
        If you believe we have inadvertently collected information from a child,
        please contact us to request its deletion.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">8. Changes to this Privacy Policy</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >We may update this Privacy Policy from time to time to reflect changes
        in our practices or for legal reasons. We will notify you of any
        material changes by posting the updated policy on the {{ appName }}
        MyApp.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2"><span class="c1">9. Contact Us</span></p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >If you have any questions or concerns about this Privacy Policy or our
        data practices, please contact us at [Your Contact Information].</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c2">
      <span class="c1"
        >By using the {{ appName }} MyApp, you acknowledge that you have
        read, understood, and agree to be bound by this Privacy Policy.</span
      >
    </p>
    <p class="c0"><span class="c1"></span></p>
    <p class="c0"><span class="c1"></span></p>
  </b-container>
</template>
<script>
export default {
  name: "Policy_Privacy",
  props: {
    resource: {
      type: Object,
      default: () => {
      }
    },
  },
  computed: {
    appName(){
      debugger;
      return  this.resource && this.resource.name ? this.resource.name : 'Awesome MyApp';
    },
    companyName(){
      return  this.resource && this.resource.name ? this.resource.name : 'Awesome MyApp';
    }
  },
};
</script>
